<template lang="pug">
  .analise
    h3.titulo-cadastar-certificado Cadastrar Certificado Digital
    el-card.card-container(shadow="hover")
      app-anexo(
        :id="'upload-atualizacao-base'"
        @uploadFile="uploadFile",
        :files="anexos",
        @removeFile="removeFile"
        @downloadDocumentoCadastro="downloadDocumentoCadastro"
        :fileType="['pfx', 'p12']"
      )
      div.buttons
      app-buttons-cadastro(
        :isPrimeiroPasso="true",
        :isUltimoPasso="true",
        @cancelar="cancelar",
        @finalizar="salvarCertificado"
      )
</template>
<script>

import FileSaver from 'file-saver'
import AppAnexo from '@/components/AppAnexo'
import AppListagem from '@/components/AppListagem'
import AppModal from '@/components/AppModal'
import axios from '@/utils/api'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import { mapActions } from 'vuex'
import AppButtonsCadastro from '@/components/AppButtonsCadastro'

export default {
  components: {
    AppAnexo,
    AppModal,
    AppListagem,
    AppButtonsCadastro
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      anexos: [],
      items: [],
      processo: undefined,
      totalElements: 0,
      usuCertificado: {
        id: 0,
        caminho: null
      }
    }
  },

  computed: {
  },

  methods: {
    ...mapActions({
      getUsuario: 'auth/getUsuario'
    }),

    async removeFile (documento) {
      this.confirmBox(this.$messages.DOCUMENTO_REMOVE_CONFIRM, this.$messages.TITULO_WARNING,
        () => {
          if (documento.id) {
            axios({
              method: 'DELETE',
              url: `documento/delete`,
              data: documento,
              responseType: 'blob'
            }).then(() => {
              this.deleteAnexo(documento)
            }).catch(() => {
              this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR,
                'Houve um erro ao remover o anexo.')
            })
          } else {
            this.deleteAnexo(documento)
          }
        },
        () => { })
    },
    cancelar () {
      this.goToListagem()
    },

    goToListagem () {
      this.$router.push({
        name: 'assinatura/home'
      })
    },

    deleteAnexo (documento) {
      if (documento.id) {
        const index = this.anexos.indexOf(this.anexos.find(a => a.id === documento.id))
        this.anexos.splice(index, 1)
      } else {
        const index = this.anexos.indexOf(this.anexos.find(a => a.key === documento.key))
        this.anexos.splice(index, 1)
      }
    },

    async getDownload (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, documento.nome)
    },

    downloadDocumentoCadastro (documento) {
      this.getDownload(documento)
    },
    uploadFile (file) {
      this.anexos = []
      this.anexos.push({
        key: file.response,
        nome: file.name
      })
    },
    salvarCertificado () {
      axios({
        method: 'POST',
        url: `documento/salvarCertificado`,
        data: this.anexos[0]
      }).then((r) => {
        this.usuCertificado.caminho = r
        this.getUsuario().then((r) => {
          this.usuCertificado.id = r.id

          axios({
            method: 'POST',
            url: `usuarios/atualizaCertificado`,
            data: this.usuCertificado
          }).then(() => {
            this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Salvas com sucesso')
          })
        })
        this.processo = undefined
        this.anexos = []
        this.showModal = false
        this.pesquisar(this.filtro)
      })

      this.getUsuario().then((r) => {
        this.usuCertificado.id = r.id
      })
      this.goToListagem()
    }

  }
}

</script>
<style>
.label {
  font-weight: bold;
}

.analise {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.card-collapse {
  border-radius: 10px;
  margin: 10px 0;
}

.btn-actions {
  display: flex;
  justify-content: space-between;
}

.flex {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.flex button {
  margin-bottom: 1em;
}

.flex .el-button span {
  display: flex;
}

.right {
  float: right;
}

.card-container {
  margin: 20px;
  border-radius: 10px;
}

.titulo-cadastar-certificado {
  margin: 20px;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/screens/assinatura/CadastroCertificado.vue